export const typesWithOptions = ['RADIO', 'CHOICES'];
export const typesWithOptionsAndDefault = ['NUMBER'];
export const typesWithCalendar = ['DATE'];
export const typesWithText = ['TEXT'];
export const typesWithOptionsRange = ['RANGE'];
export const typesDeficiencies = ['MAINTAIN_MONITOR', 'ATTANCHENED_NEEDED', 'ACTION_NECESSARY'];
